<div class="container-fluid px-0 h-100">
    <div class="h-100  d-flex  justify-content-between">
        <!-- card 1 -->
        <div class="flex-grow-1 px-3 container_content">
            <div class="row justify-content-center">
                <div class="m-w-520 py-md-5 col-12">
                    <!-- main page login starts  -->
                    <div class="row py-md-5 py-4 flex-wrap">
                        <div class="col-12 mt-3">
                            <img src="assets/img/svg/logo_login.svg" alt="" srcset="">
                        </div>
                        <div class="col-12 mt-5">
                            <h1 class="h1 f-w-800">
                                {{'FORGOT' | titlecase}} <span style="color:var(--d-blue)">{{'PASSWORD!' | titlecase }}</span>
                            </h1>
                        </div>

                        <form name="loginForm" [formGroup]="user" class="m-w-520 w-100" (submit)="submitForm(user)">

                            <div class="col-12 form-group my-4">
                                <div [ngClass]="[ (user.controls.email.invalid && user.controls.email.touched)   ? 'custom-form  inputContainer' : 'custom-form']">
                                    <input type="text" class="input_field pt-3 px-3" formControlName="email" required
                                        name="email"/>
                                    <label for="text" class="label-name">
                                        <span class="content-name f-c-p-3">
                                            Enter your Email
                                        </span>
                                    </label>
                                </div>
                                <p class="mat-error" *ngIf=" (user.controls.email.invalid && user.controls.email.touched)">Please enter a valid email</p>
                            </div>
                            <div class="col-12 form-group">
                                <button button-primary-auth type="submit"
                                    class="me-3 mt-2 mt-sm-0 px-5 col-12 " [disabled]="user.invalid">Send Email</button>
                                <!-- <button button-login class=" mt-2 mt-sm-0 col-12 " (click)="GenerateOtp()">Generate OTP</button> -->
                            </div>

                            <div class="w-100 h-6 fw-bold col-12 pointer mt-5 h6">
                                <span class="f-c-p-1">
                                  Already have an account ?<a routerLink="/login" class="d-blue"> Login</a>
                                </span>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div class=" d-sm-none d-none d-sm-none d-md-block img_bg container_carousel flex-grow-1 m-w-40p">
            <app-carousel></app-carousel>
        </div>
    </div>
</div>